import React from 'react';
import PropTypes from 'prop-types';

import BrokerCommission from './broker_commission';

export default class ListingQuickUpdateFormBrokerCommissions extends React.Component {
  static propTypes = {
    commissions: PropTypes.arrayOf(PropTypes.shape({
      brokerId: PropTypes.number.isRequired
    })).isRequired,
    descriptor: PropTypes.string,
    disabled: PropTypes.bool,
    listing: PropTypes.shape({
      listingStatus: PropTypes.string.isRequired
    }).isRequired,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    descriptor: ''
  }

  render() {
    const { commissions, descriptor, disabled, listing, onChange } = this.props;

    if (commissions.length === 0) {
      return null;
    }

    const estimatedLabel = listing.listingStatus === 'closed' ? '' : 'estimated';
    let header;
    if (commissions.length === 1) {
      header = `What is the ${estimatedLabel} ${descriptor} commission?`;
    } else {
      header = `What are the ${estimatedLabel} ${descriptor} commissions?`;
    }

    return (
      <div className="form-group">
        <div className="fs-large">{header}</div>
        {commissions.map((commission, i) => (
          <BrokerCommission
            commission={commission}
            disabled={disabled}
            key={i}
            onChange={onChange}
          />
        ))}
      </div>
    );
  }
}
